import { Component, OnInit } from '@angular/core';

import { LoginService } from 'src/app/login/login.service';
import { MenuOptionsService } from './menu-options.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu-options',
  templateUrl: './menu-options.component.html',
  styleUrls: ['./menu-options.component.css']
})
export class MenuOptionsComponent implements OnInit {


  active_link=""
  items
  release_notes_show = false;

  constructor(public oidcSecurityService:OidcSecurityService,private router:Router,public menuService:MenuOptionsService) { }

  ngOnInit(): void {
    this.release_notes_show = false;
    this.items = [
      {label: 'Logout', icon: 'pi pi-sign-out', command: () => { this.signout() }},
      {label: 'User Manual', icon: 'pi pi-fw pi-download', command: () => { this.downloadManual() }},
      {label: 'Release Notes', icon: 'pi pi-exclamation-circle', command: () => { this.release_notes_show=true }},
      {label: 'Feedback', icon: 'pi pi-envelope', command: () => { this.emailFeedbacks() }},
    ];
  }

  signout(){
    this.oidcSecurityService.logoff();
  }

  downloadManual() {
    const link = document.createElement('a');
    link.href = 'assets/user-manual.pdf';
    link.download = 'User-Manual.pdf';
    link.click();
  }

  emailFeedbacks() {
    const recipient = 'AU-Driven-Support@slb001.onmicrosoft.com';
    const subject = encodeURIComponent('Feedback for Driven');
    const body = encodeURIComponent('Hi Team,\n\nI would like to share the following feedback:\n\n');
    
    window.location.href = `mailto:${recipient}?subject=${subject}&body=${body}`;
  }

  navigate_to(url){
    this.menuService.active_link=url;
    this.router.navigate([url])
  }

}
